<template>
  <NuxtLayout
    :is-menu-hidden="page?.is_menu_hidden"
    :is-footer-hidden="page?.is_footer_hidden"
    should-add-margin-top-into-main-content
  >
    <div>
      <CourseCover v-if="page" :course="page" />
      <Widgets v-if="page?.widgets" :widgets="page?.widgets" without-h1 />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const route = useRoute()
const slug = flatten(route.params.slug)
const { data: page, error } = await useAsyncData('courseSlug', async () =>
  useApi().publicPagesCourseAndEventsRetrieve(slug)
)

if (error.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
}

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    'pl-pl': '/kurs/[slug]'
  }
})

const setI18nParams = useSetI18nParams()
setI18nParams({
  'pl-pl': { slug: page?.value?.slug_pl },
  'pl-en': { slug: page?.value?.slug_en }
})

const { meta } = usePrepareSEOHead(page)
useHead({
  title: page.value?.title,
  meta
})
</script>
